import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@material-ui/core";
import { Action } from "pages/CreateSchedulerRule/components";
import { useFieldArray, useFormContext } from "react-hook-form";
import { ActionViewModel } from "validation";

/**
 * Action wrapper
 */
export const ActionSection = () => {
    const { t } = useTranslation();
    const { control } = useFormContext<{ actions: ActionViewModel[] }>();
    const { fields, remove, append } = useFieldArray<ActionViewModel>({
        control,
        name: "actions",
    });

    const handleAddAction = useCallback(() => {
        append({
            startsAt: {
                days: "0",
                hours: "0",
                minutes: "0",
            },
            status: "",
            template: "",
        });
    }, [append]);

    return (
        <Box mb={4}>
            <Box display="flex" alignItems="flex-end">
                <Box display="flex" mr={2} flex={0.85}>
                    <Typography component="div" variant="subtitle2">
                        <Box fontWeight="fontWeightBold">Actions ({fields.length})</Box>
                    </Typography>
                </Box>
                <Box display="flex" flex={0.15} justifyContent="flex-end">
                    <Button variant="contained" color="primary" onClick={handleAddAction}>
                        {t("buttons.label.addAction")}
                    </Button>
                </Box>
            </Box>
            {fields.map((action, index) => {
                const isOrphan = fields.length === 1;

                return (
                    <Action
                        key={action.id}
                        item={action}
                        isDeleteDisabled={isOrphan}
                        index={index}
                        title={`${index + 1}. reminder`}
                        onRemoveAction={remove}
                    />
                );
            })}
        </Box>
    );
};
